module.exports = __webpack_public_path__ + "static/media/Logo.3dc7ff74.png";